import { CloudOutlineIcon } from './CloudOutlineIcon';

/**
 * author: Google
 * id 6EBE020D-405B-4E36-8B47-CAC6FAF1166C
 * name cloud-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cloud-outline.svg
 * tags
 * - Cloud 
 * - Weather 
 */
export const CloudQueueIcon = CloudOutlineIcon;
export default CloudQueueIcon